import React, { useEffect, useState } from "react";
import MainNavbar from "../../MainNavbar/MainNavbar";
import { Footer } from "../../Footer";
import { useNavigate } from "react-router-dom";
import { ModalPlan } from "../../../designs/modalEdit/ModalPlan";
import PreguntasFrecuentes from "./PreguntasFrecuentes";

let DATA = {
    starter: {
        una_casa: 12,
        casa_adicional: 2,
    },

    standard: {
        una_casa: 25,
        casa_adicional: 3,
    },
    premium: {
        una_casa: 40,
        casa_adicional: 5,
    },
};

const Planes = () => {
    const [Plan, setPlan] = useState("Mensual");
    const [meses, setMeses] = useState<number>(1);
    const [numberHouse, setNumberHouse] = useState<number>(1);
    const [moneda, setMoneda] = useState("$");
    const [tipoPlan, setTipoPlan] = useState(0);
    const [showModal, setShowModal] = useState(false);

    const [activeButton, setActiveButton] = useState(null);
    const navigate = useNavigate();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const handlePlan = (planString: string) => {
        setPlan(planString);
    };

    const handleButtonClick = (button: any) => {
        setActiveButton(button);
        if (button === "+") {
            setNumberHouse(Number(numberHouse) + 1);
        }

        if (button === "-") {
            if (numberHouse === 1) return;
            setNumberHouse(Number(numberHouse) - 1);
        }
    };

    const handleOutsideClick = () => {
        setActiveButton(null);
    };

    const handleChange = (e: any) => {
        const value = e.target.value;

        // Verifica que el valor sea un número y que sea al menos 1
        if (/^\d*$/.test(value) && (value === "" || parseInt(value) >= 1)) {
            setNumberHouse(value); // Solo actualiza si pasa las validaciones
        }
    };

    useEffect(() => {
        // Agrega el evento de clic al documento
        document.addEventListener("click", handleOutsideClick);
        return () => {
            // Limpia el evento al desmontar el componente
            document.removeEventListener("click", handleOutsideClick);
        };
    }, []);

    const handleComprarPlan = () => {
        navigate(`/registro-corredor/${!Plan ? "1" : "2"}/${numberHouse}`);
    };

    const getStarter = ({
        tipo,
        descuento = false,
    }: {
        tipo: string;
        descuento?: boolean;
    }) => {
        let porcentaje = 0;

        if (tipo === "Semestral") {
            porcentaje = 0.9;
        }

        if (tipo === "Anual") {
            porcentaje = 0.8;
        }

        if (tipo === "Bi Anual") {
            porcentaje = 0.7;
        }
        let price =
            numberHouse < 2
                ? DATA.starter.una_casa
                : Number(DATA.starter.una_casa) +
                  Number(DATA.starter.casa_adicional) *
                      (Number(numberHouse) - 1);
        if (descuento) {
            price = Math.ceil(price * porcentaje);
        }

        return price * 12;
    };

    const getStandard = ({
        tipo,
        descuento = false,
    }: {
        tipo: string;
        descuento?: boolean;
    }) => {
        let porcentaje = 0;

        if (tipo === "Semestral") {
            porcentaje = 0.9;
        }

        if (tipo === "Anual") {
            porcentaje = 0.8;
        }

        if (tipo === "Bi Anual") {
            porcentaje = 0.7;
        }
        let price =
            numberHouse < 2
                ? DATA.standard.una_casa
                : Number(DATA.standard.una_casa) +
                  Number(DATA.standard.casa_adicional) *
                      (Number(numberHouse) - 1);
        if (descuento) {
            price = Math.ceil(price * porcentaje);
        }

        return price * 12;
    };

    const getPremium = ({
        tipo,
        descuento = false,
    }: {
        tipo: string;
        descuento?: boolean;
    }) => {
        let porcentaje = 0;

        if (tipo === "Semestral") {
            porcentaje = 0.9;
        }

        if (tipo === "Anual") {
            porcentaje = 0.8;
        }

        if (tipo === "Bi Anual") {
            porcentaje = 0.7;
        }

        let price =
            numberHouse < 2
                ? DATA.premium.una_casa
                : Number(DATA.premium.una_casa) +
                  Number(DATA.premium.casa_adicional) *
                      (Number(numberHouse) - 1);
        if (descuento) {
            price = Math.ceil(price * porcentaje);
        }

        return price * 12;
    };

    return (
        <div className=" bg-[#ffffff] w-full">
            <MainNavbar />
            {showModal && tipoPlan && (
                <ModalPlan
                    setModalVisibleComodidades={setShowModal}
                    modalVisibleComodidades={showModal}
                    comprar={true}
                    unidades={numberHouse}
                    tipo_pago={
                        Plan === "Mensual"
                            ? 0
                            : Plan === "Semestral"
                            ? 1
                            : Plan === "Anual"
                            ? 2
                            : 3
                    }
                    plan={tipoPlan}
                />
            )}
            <div className=" mt-8 lg:pt-20 pt-10 bg-[#ffffff] 3xl:w-2/3 2xl:w-3/4 lg:w-4/5 w-5/6 mx-auto ">
                <div className="flex flex-col justify-start h-auto mb-5 md818:mb-10  ">
                    <div className="text-[#071829] 2xl:text-4xl xl:text-3xl text-2xl font-bold md:w-2/3 text-center md:text-left  ">
                        Elige el plan ideal para tu negocio y mejora la gestión
                        de alojamientos.
                    </div>

                    <p className="text-[#071829] 2xl:text-xl xl:text-base lg:text-base md:text-sm text-xs  mt-5 lg:w-1/2 md:w-2/3 text-center md:text-left  ">
                        Descubre nuestras opciones Starter, Estándar y Premium,
                        pensadas para optimizar reservas, comunicación y
                        experiencia del cliente.
                    </p>
                </div>

                <div className="flex md:flex-row flex-col md:gap-0 gap-5 items-center justify-between md:mt-0 mt-8  ">
                    <div className="flex flex-col items-center justify-center lg:gap-4 md:gap-3 gap-2">
                        <div className="flex items-center justify-center px-1 py-0.5 border-2 bg-[#029DE0] bg-opacity-10 md:w-96 w-80 rounded-3xl">
                            <div
                                className={`${
                                    Plan === "Bi Anual"
                                        ? "bg-[#C3EA43] font-bold"
                                        : " text-[#0E1928]"
                                }   text-center  rounded-3xl cursor-pointer w-1/2 py-2 h-full `}
                                onClick={() => {
                                    handlePlan("Bi Anual");
                                    setMeses(24);
                                }}
                            >
                                <p className="xl:text-base md:text-sm text-xs ">
                                    Bi Anual
                                </p>
                            </div>
                            <div
                                className={`${
                                    Plan === "Anual"
                                        ? "bg-[#C3EA43] font-bold"
                                        : " text-[#0E1928]"
                                }   text-center rounded-3xl  cursor-pointer w-1/2 py-2 h-full `}
                                onClick={() => {
                                    handlePlan("Anual");
                                    setMeses(12);
                                }}
                            >
                                <p className="xl:text-base md:text-sm text-xs ">
                                    Anual
                                </p>
                            </div>

                            <div
                                className={`${
                                    Plan === "Semestral"
                                        ? "bg-[#C3EA43] font-bold"
                                        : " text-[#0E1928]"
                                }   text-center rounded-3xl  cursor-pointer w-1/2 py-2 h-full `}
                                onClick={() => {
                                    handlePlan("Semestral");
                                    setMeses(6);
                                }}
                            >
                                <p className="xl:text-base md:text-sm text-xs ">
                                    Semestral
                                </p>
                            </div>
                            <div
                                className={` ${
                                    Plan === "Mensual"
                                        ? "bg-[#C3EA43] font-bold"
                                        : " text-[#0E1928]"
                                }   px-4 text-lg   rounded-3xl cursor-pointer w-1/2 h-full py-2 text-center`}
                                onClick={() => {
                                    handlePlan("Mensual");
                                    setMeses(1);
                                }}
                            >
                                <p className="xl:text-base md:text-sm text-xs ">
                                    Mensual
                                </p>
                                <p
                                    className={`text-[8px] w-full  mb-1 ${
                                        Plan === "Mensual"
                                            ? "text-[#0E1928]"
                                            : " text-[#0E1928]"
                                    }`}
                                ></p>
                            </div>
                        </div>
                    </div>
                    <div className="flex md:flex-row flex-col items-center justify-center gap-4">
                        <div className="xl:text-base  text-sm  text-center md:text-left ">
                            Elije el número de unidades
                        </div>
                        <div className="flex items-center justify-center gap-2 p-1.5 border-2 border-[#029DE0] rounded-full">
                            <div
                                className={` ${
                                    activeButton === "-"
                                        ? " bg-gray-300"
                                        : "bg-[#D9D9D9]"
                                }  rounded-full md:h-8 h-7 md:w-8 w-7 flex justify-center items-center cursor-pointer  `}
                                onClick={(e) => {
                                    e.stopPropagation(); // Evita que el clic en este botón cierre el estado activo
                                    handleButtonClick("-");
                                    // Aquí puedes manejar la lógica para restar
                                }}
                            >
                                <span className="mb-1 md:text-2xl text-xl  leading-none">
                                    -
                                </span>
                            </div>
                            <div className="flex items-center justify-center h-8  rounded-md">
                                <input
                                    type="text"
                                    className="w-8 md:text-lg text-base text-center "
                                    value={numberHouse}
                                    onChange={handleChange}
                                />
                            </div>
                            <div
                                className={`border-2 ${
                                    activeButton === "+"
                                        ? " bg-gray-300"
                                        : "bg-[#D9D9D9]"
                                }  rounded-full md:h-8 h-7 md:w-8 w-7 flex justify-center items-center cursor-pointer`}
                                onClick={(e) => {
                                    e.stopPropagation(); // Evita que el clic en este botón cierre el estado activo
                                    handleButtonClick("+");
                                    // Aquí puedes manejar la lógica para restar
                                }}
                            >
                                <span className="mb-1 md:text-2xl text-xl  leading-none">
                                    +
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="flex flex-col lg:items-start items-center lg:justify-between justify-center w-full gap-6  mx-auto mt-5 lg:flex-row  ">
                    <div className="flex flex-col  rounded-2xl border border-[#D5D8E2]  md:h-[780px] h-[700px] w-[330px] mb-4 relative">
                        <div className="bg-[#029DE0] rounded-t-2xl h-2 "></div>
                        <div className="px-5 pt-7">
                            <div
                                className={`text-[#0E1928] text-base md:text-lg xl:text-xl font-bold  ${"mt-5"} `}
                            >
                                Starter
                            </div>

                            <div className="flex flex-col gap-8 md:gap-0">
                                <div className="flex flex-col border-b border-[#D5D8E2] border-dashed pb-5  ">
                                    <div className="flex items-end text-[#0E1928] text-2xl md:text-3xl xl:text-5xl   mt-2">
                                        {Plan === "Mensual" ? (
                                            <div className="flex">
                                                <p className="text-4xl font-bold">
                                                    {moneda}
                                                </p>
                                                <p className="text-4xl font-bold">
                                                    {(numberHouse < 3
                                                        ? DATA.starter.una_casa
                                                        : Number(
                                                              DATA.starter
                                                                  .una_casa
                                                          ) +
                                                          Number(
                                                              DATA.starter
                                                                  .casa_adicional
                                                          ) *
                                                              (Number(
                                                                  numberHouse
                                                              ) -
                                                                  2)
                                                    ).toFixed(2)}
                                                </p>
                                            </div>
                                        ) : (
                                            <div className="flex text-[#179BD8]">
                                                <p className="text-4xl font-bold">
                                                    {moneda}
                                                </p>
                                                <p className="text-4xl  font-bold">
                                                    {" "}
                                                    {(
                                                        getStarter({
                                                            tipo: Plan,
                                                            descuento: true,
                                                        }) / 12
                                                    ).toFixed(2)}
                                                </p>
                                            </div>
                                        )}

                                        <div className="text-base font-semibold xl:text-lg">
                                            /mes
                                        </div>
                                    </div>
                                    <div className="text-[#0E1928]  text-sm  flex items-center gap-1 mt-2">
                                        {moneda}
                                        {Plan === "Mensual"
                                            ? getStarter({
                                                  tipo: Plan,
                                              })
                                            : getStarter({
                                                  tipo: Plan,
                                                  descuento: true,
                                              })}{" "}
                                        al año.
                                        {Plan === "Semestral" && (
                                            <div className="text-[#179BD8] text-xs md:text-sm  font-bold">
                                                Ahorras 10%
                                            </div>
                                        )}
                                        {Plan === "Anual" && (
                                            <div className="text-[#179BD8] text-xs md:text-sm  font-bold">
                                                Ahorras 20%
                                            </div>
                                        )}
                                        {Plan === "Bi Anual" && (
                                            <div className="text-[#179BD8] text-xs md:text-sm  font-bold">
                                                Ahorras 30%
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <div className="flex flex-col mb-8 ">
                                    <div
                                        className={`text-[#0E1928] text-sm  md:mt-4 mb-0`}
                                    >
                                        <p className="text-sm md:text-lg">
                                            El plan incluye:{" "}
                                        </p>
                                        <div className="marker:text-[#0E1928] text-xs md:text-base mt-3 flex flex-col justify-center items-start">
                                            {[
                                                "Diseños personalizados de página web.",
                                                "Contar con un subdominio.",
                                                "Calendario de reservas.",
                                                "Módulos de contactos.",
                                                "Tarifas adicionales (Limpieza, Guardia, Mantenimiento, otros).",
                                                "E-mail resumen de alquiler o reserva para el propietario y cliente.",
                                                "Pagos vía transferencia bancaria.",
                                                "Sección de reseñas de los clientes.",
                                            ].map((text, index) => (
                                                <div
                                                    key={index}
                                                    className="mb-2 flex items-center gap-x-2"
                                                >
                                                    <svg
                                                        width="29"
                                                        height="29"
                                                        viewBox="0 0 29 29"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        className="flex-shrink-0"
                                                    >
                                                        <path
                                                            d="M8.43373 15.0943L11.8289 18.4895L19.5894 10.729"
                                                            stroke="#282A37"
                                                            strokeWidth="1.75048"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                        />
                                                    </svg>
                                                    <p className="flex-1">
                                                        {text}
                                                    </p>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div
                            onClick={() => {
                                window.open(
                                    "https://calendar.app.google/7aKBqkaqESiPuTtE8"
                                );
                            }}
                            className="absolute bottom-10 left-1/2 -translate-x-1/2 border rounded-full py-2 w-52 text-center cursor-pointer border-[#029DE0] text-[#029DE0] text-xs md:text-base hover:scale-105 "
                        >
                            Agenda tu demo
                        </div>
                    </div>

                    <div className="flex flex-col  rounded-2xl border border-[#D5D8E2]  md:h-[780px] h-[700px] w-[330px] mb-4 relative">
                        <div className="bg-[#071829] rounded-t-2xl h-2 "></div>
                        <div className="px-5 pt-10 ">
                            <div
                                className={`text-[#0E1928] text-base md:text-lg xl:text-xl font-bold  ${"mt-5"} `}
                            >
                                <p className="text-base md:text-lg xl:text-xl font-bold  ">
                                    Estándar
                                </p>{" "}
                                {/*    */}
                            </div>

                            <div className="flex flex-col gap-8 md:gap-0">
                                <div className="flex flex-col border-b border-[#D5D8E2] border-dashed pb-5  ">
                                    <div className="flex items-end text-[#0E1928] text-2xl md:text-3xl xl:text-5xl   mt-2">
                                        {Plan === "Mensual" ? (
                                            <div className="flex">
                                                <p className="text-4xl font-bold">
                                                    {moneda}
                                                </p>
                                                <p className="text-4xl font-bold">
                                                    {" "}
                                                    {(numberHouse < 3
                                                        ? DATA.standard.una_casa
                                                        : Number(
                                                              DATA.standard
                                                                  .una_casa
                                                          ) +
                                                          Number(
                                                              DATA.standard
                                                                  .casa_adicional
                                                          ) *
                                                              (Number(
                                                                  numberHouse
                                                              ) -
                                                                  2)
                                                    ).toFixed(2)}
                                                </p>
                                            </div>
                                        ) : (
                                            <div className="flex text-[#179BD8]">
                                                <p className="text-4xl font-bold">
                                                    {moneda}
                                                </p>
                                                <p className="text-4xl  font-bold  ">
                                                    {(
                                                        getStandard({
                                                            tipo: Plan,
                                                            descuento: true,
                                                        }) / 12
                                                    ).toFixed(2)}
                                                </p>
                                            </div>
                                        )}

                                        <div className="text-base font-semibold xl:text-lg">
                                            /mes
                                        </div>
                                    </div>
                                    <div className="flex items-center gap-1 mt-2 text-sm ">
                                        {moneda}
                                        {Plan === "Mensual"
                                            ? getStandard({
                                                  tipo: Plan,
                                              })
                                            : getStandard({
                                                  tipo: Plan,
                                                  descuento: true,
                                              })}{" "}
                                        al año.
                                        {Plan === "Semestral" && (
                                            <div className="text-[#179BD8] text-xs md:text-sm  font-bold">
                                                Ahorras 10%
                                            </div>
                                        )}
                                        {Plan === "Anual" && (
                                            <div className="text-[#179BD8] text-xs md:text-sm  font-bold">
                                                Ahorras 20%
                                            </div>
                                        )}
                                        {Plan === "Bi Anual" && (
                                            <div className="text-[#179BD8] text-xs md:text-sm  font-bold">
                                                Ahorras 30%
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <div className="flex flex-col mb-7 text-[#0E1928] ">
                                    <div className={` text-sm  md:mt-4 mb-0`}>
                                        <p className="text-sm md:text-lg">
                                            El plan incluye:{" "}
                                        </p>

                                        <div className=" text-xs md:text-base mt-3 flex flex-col justify-center items-start">
                                            {[
                                                "Incluye el Plan Starter",
                                                "Opción de descuento por estadía por número de noches (ej. 7 días, 15 días, etc).",
                                                "Precios dinámicos por dia de semana y/o fin de semana.",
                                                "Módulo de chat.",
                                                "Módulo de CRM.",
                                                "Módulo de Dashboard con estadísiticas.",
                                                "Creación de cupones de descuento.",
                                            ].map((text, index) => (
                                                <div
                                                    key={index}
                                                    className="mb-2 flex items-center gap-x-2"
                                                >
                                                    <svg
                                                        width="29"
                                                        height="29"
                                                        viewBox="0 0 29 29"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        className="flex-shrink-0"
                                                    >
                                                        <path
                                                            d="M8.43373 15.0943L11.8289 18.4895L19.5894 10.729"
                                                            stroke="#282A37"
                                                            strokeWidth="1.75048"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                        />
                                                    </svg>
                                                    <p
                                                        className={`flex-1 ${
                                                            index === 0
                                                                ? "font-bold"
                                                                : ""
                                                        } `}
                                                    >
                                                        {text}
                                                    </p>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div
                            onClick={() => {
                                window.open(
                                    "https://calendar.app.google/7aKBqkaqESiPuTtE8"
                                );
                            }}
                            className="absolute bottom-10 left-1/2 -translate-x-1/2 border rounded-full py-2 w-52 text-center cursor-pointer border-[#029DE0] text-[#029DE0] text-xs md:text-base hover:scale-105 "
                        >
                            Agenda tu demo
                        </div>
                    </div>

                    <div className="flex flex-col  rounded-2xl border border-[#D5D8E2]  md:h-[780px] h-[700px] w-[330px] mb-4 relative">
                        <p className="text-xs text-[#071829] bg-[#C0D345] rounded-lg font-bold px-3 py-1 absolute top-7 left-5">
                            El más seleccionado
                        </p>
                        <div className="bg-[#C0D345] rounded-t-2xl h-2 "></div>
                        <div className="px-5 pt-8">
                            <div
                                className={`text-[#0E1928] text-base md:text-lg xl:text-xl font-bold  ${"mt-5"} `}
                            >
                                Premium
                            </div>

                            <div className="flex flex-col gap-8 md:gap-0">
                                <div className="flex flex-col border-b border-[#D5D8E2] border-dashed pb-5  ">
                                    <div className="flex items-end  text-2xl md:text-3xl xl:text-5xl   mt-2">
                                        {Plan === "Mensual" ? (
                                            <div className="flex">
                                                <p className="text-4xl font-bold">
                                                    {moneda}
                                                </p>
                                                <p className="text-4xl font-bold">
                                                    {" "}
                                                    {(numberHouse < 3
                                                        ? DATA.premium.una_casa
                                                        : Number(
                                                              DATA.premium
                                                                  .una_casa
                                                          ) +
                                                          Number(
                                                              DATA.premium
                                                                  .casa_adicional
                                                          ) *
                                                              (Number(
                                                                  numberHouse
                                                              ) -
                                                                  2)
                                                    ).toFixed(2)}
                                                </p>
                                            </div>
                                        ) : (
                                            <div className="flex">
                                                <p className="text-4xl font-bold">
                                                    {moneda}
                                                </p>
                                                <p className="text-4xl  font-bold">
                                                    {" "}
                                                    {(
                                                        getPremium({
                                                            tipo: Plan,
                                                            descuento: true,
                                                        }) / 12
                                                    ).toFixed(2)}
                                                </p>
                                            </div>
                                        )}

                                        <div className="text-base font-semibold xl:text-lg">
                                            /mes
                                        </div>
                                    </div>
                                    <div className="text-[#0E1928]  text-sm  flex items-center gap-1 mt-2">
                                        {moneda}
                                        {Plan === "Mensual"
                                            ? getPremium({
                                                  tipo: Plan,
                                              })
                                            : getPremium({
                                                  tipo: Plan,
                                                  descuento: true,
                                              })}{" "}
                                        al año.
                                        {Plan === "Semestral" && (
                                            <div className="text-[#179BD8] text-xs md:text-sm  font-bold">
                                                Ahorras 10%
                                            </div>
                                        )}
                                        {Plan === "Anual" && (
                                            <div className="text-[#179BD8] text-xs md:text-sm  font-bold">
                                                Ahorras 20%
                                            </div>
                                        )}
                                        {Plan === "Bi Anual" && (
                                            <div className="text-[#179BD8] text-xs md:text-sm  font-bold">
                                                Ahorras 30%
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <div className="flex flex-col mb-8 ">
                                    <div
                                        className={`text-[#0E1928] text-sm  md:mt-4 mb-0`}
                                    >
                                        <p className="text-sm md:text-lg">
                                            El plan incluye:{" "}
                                        </p>
                                        <div className="marker:text-[#0E1928] text-xs md:text-base mt-3 flex flex-col justify-center items-start">
                                            {[
                                                "Incluye el Plan Estándar",
                                                "Integración de calendarios de Airbnb, booking, google calendar, entre otros.",
                                                "Chatroom (integración con Whatsapp).",
                                                "Chatbot.",
                                                "Envio de promociones y descuentos via e-mail y chat a tus contactos.",
                                                "Propuesta de alquileres por cliente personalizada.",
                                                "Contratos propietario - huésped.",
                                                "Firma de contratos.",
                                            ].map((text, index) => (
                                                <div
                                                    key={index}
                                                    className="mb-2 flex items-center gap-x-2"
                                                >
                                                    <svg
                                                        width="29"
                                                        height="29"
                                                        viewBox="0 0 29 29"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        className="flex-shrink-0"
                                                    >
                                                        <path
                                                            d="M8.43373 15.0943L11.8289 18.4895L19.5894 10.729"
                                                            stroke="#FFFFFF"
                                                            strokeWidth="1.75048"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                        />
                                                    </svg>
                                                    <p
                                                        className={`flex-1 ${
                                                            index === 0
                                                                ? "font-bold"
                                                                : ""
                                                        } `}
                                                    >
                                                        {text}
                                                    </p>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div
                            onClick={() => {
                                window.open(
                                    "https://calendar.app.google/7aKBqkaqESiPuTtE8"
                                );
                            }}
                            className="absolute bottom-10 left-1/2 -translate-x-1/2 border rounded-full py-2 w-52 text-center cursor-pointer bg-gradient-to-r from-[#029DE0] to-[#44C7FF] text-white text-xs md:text-base hover:scale-105 "
                        >
                            Agenda tu demo
                        </div>
                    </div>
                </div>

                <PreguntasFrecuentes />
            </div>
            <Footer />
        </div>
    );
};

export default Planes;
